import Phaser from 'phaser';

export default class Win98Window extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y, spritesheet, text) {
        super(scene, x, y, spritesheet, 0);
        scene.add.existing(this);
        
        scene.sound.play('98ding', { volume: 0.7 });

        // Add text overlay
        this.messageText = scene.add.text(x + 20, y + 20, text, {
            fontFamily: 'Microsoft Sans Serif',
            fontSize: '14px',
            color: '#000000',
            wordWrap: { width: 160 }  // Adjusted for 200px width
        });
        this.messageText.setOrigin(.6, 1);
        
        this.setInteractive();
        
        // Define clickable areas based on spritesheet
        this.okayButton = new Phaser.Geom.Rectangle(80, 154, 100, 22);  // "Ape it" button
        this.closeButton = new Phaser.Geom.Rectangle(210, 10, 14, 14);  // X button
        
        // const debugGraphics = scene.add.graphics({ lineStyle: { width: 1, color: 0xff0000 }, fillStyle: { color: 0xff0000, alpha: 0.3 } });
        // debugGraphics.strokeRectShape(this.okayButton);
        // debugGraphics.fillRectShape(this.okayButton);
        // debugGraphics.strokeRectShape(this.closeButton);
        // debugGraphics.fillRectShape(this.closeButton);

        // Track button states
        this.isOkayPressed = false;
        this.isClosePressed = false;
        
        // Setup input handlers
        this.on('pointerdown', this.handleClick);
        this.on('pointerup', this.handleRelease);
        
        this.onOkayClick = null;
        this.onCloseClick = null;
    }
    
    handleClick(pointer) {
        if (this.okayButton.contains(pointer.x, pointer.y)) {
            this.setFrame(1);
            this.isOkayPressed = true;
        }
        else if (this.closeButton.contains(pointer.x, pointer.y)) {
            this.setFrame(2);
            this.isClosePressed = true;
        }
    }

   handleRelease(pointer) {
        if (this.isOkayPressed && this.okayButton.contains(pointer.x, pointer.y)) {
            if (this.onOkayClick) this.onOkayClick();
        }
        else if (this.isClosePressed && this.closeButton.contains(pointer.x, pointer.y)) {
            if (this.onCloseClick) this.onCloseClick();
            this.messageText.destroy();
            this.destroy();
        }
        
        this.setFrame(0);
        this.isOkayPressed = false;
        this.isClosePressed = false;
    }
    
    setOkayCallback(callback) {
        this.onOkayClick = callback;
    }
    
    setCloseCallback(callback) {
        this.onCloseClick = callback;
    }

    destroy(fromScene) {
        this.messageText.destroy();
        super.destroy(fromScene);
    }
}
